import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=5c1ada23&scoped=true"
import script from "./focus.vue?vue&type=script&lang=js"
export * from "./focus.vue?vue&type=script&lang=js"
import style0 from "./focus.vue?vue&type=style&index=0&id=5c1ada23&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ada23",
  null
  
)

export default component.exports